import {formatDate} from 'common/helpers'

export const getCurrentPeriod = (periods: any[], key: string): any =>
  periods.find((item) => item.key === key)

export const createCustomPeriod = (period: any[] = []) => {
  const [fromDate, toDate] = period
  const isDates = Boolean(fromDate && toDate)

  return {
    key: 'custom',
    label: 'Custom period…',
    tip: isDates
      ? `${formatDate(fromDate, 'fifth')} - ${formatDate(toDate, 'fifth')}`
      : '',
    period: isDates
      ? {
          dateFrom: formatDate(fromDate, 'server'),
          dateTo: formatDate(toDate, 'server'),
        }
      : {},
  }
}
